import React, { FC } from 'react'
import { useFlag } from 'constants/flags'

import CardNumberInputV1 from './CardNumberInput'
import CardNumberInputV2, { CardNumberInputProps } from './CardNumberInputV2'

export { default as CardExpiryInput } from './CardExpiryInput'
export { default as CardCVCInput } from './CardCVCInput'

export const CardNumberInput: FC<CardNumberInputProps> = props => {
  // Remove usages of 'onboarding-licenses-signup' feature flag
  // https://github.com/sketch-hq/Cloud/issues/10012
  const isOnboardingLicensesSignUpOn = useFlag('onboarding-licenses-signup')

  return isOnboardingLicensesSignUpOn ? (
    <CardNumberInputV2 {...props} />
  ) : (
    <CardNumberInputV1 {...props} />
  )
}
